import React from 'react';
import Page from '../base/Page';
import { Button, Radio, Input, Spin, Empty, Alert, Checkbox, Select } from 'antd';

import { 
    PlusOutlined,
    UnorderedListOutlined,
    LockOutlined
} from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import Api from '../session/Api';
import { withRouter } from 'react-router-dom';
import TutorLiveSessionItem from '../views/live-sessions/TutorLiveSessionItem';

import InfiniteScroll from 'react-infinite-scroller';
import { NO_PAGE_TOKEN, PAGINATION_PAGE_CONTENT_COUNT } from '../Constants';
import UIUtil from '../util/UIUtil';
import withMediaQuery from '../components/WithMediaQuery';
import Util from '../util/Util';
import { CATEGORIES } from '../Categories';

const { Option } = Select;

class TutorMyLiveSessionsPage extends Page {

    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            createLiveSession: false,
            createLiveSessionTitle: "",
            createLiveSessionCategory: 0,
            createLiveSessionPrivate: false,
            creatingLiveSession: false,

            items: [],
            page: NO_PAGE_TOKEN,
            hasMore: true,
            loadingItems: false,
        }
    }

    getNextLiveSessions() {
        if (this.state.loadingItems) {
            return;
        }

        this.setState({
            loadingItems: true
        })

        //list error
        const listener = response => {
            if (response.status === true) {
                let items = this.state.items;
                items.push(...response.payload.items);

                this.setState({
                    items: items,
                    page: response.payload.token,
                    hasMore: Util.isStringExists(response.payload.token),
                    loadingItems: false
                })
            } else {
                //alert('errowr');
            }
        };

        if (this.props.showCourseLiveSessions) {
            Api.getTutorCourseLiveSessions(this.props.courseId, this.state.page, listener);
        } else if (this.props.organization !== undefined) {
            Api.getMyTutorOrganizationLiveSessions(this.props.organization.id, this.state.page, listener);
        } else {
            Api.getMyTutorLiveSessions(this.state.page, listener);
        }
    }

    onCreateLiveSession() {
        this.setState({creatingLiveSession: true});
        const listener = response => {
            if (response.status === true) {
                this.setState({
                    createLiveSession: false, 
                    createLiveSessionTitle: "",
                    createLiveSessionCategory: 0,
                    createLiveSessionPrivate: false,
                    creatingLiveSession: false
                })
                this.props.history.push("/my-live-session/" + response.payload + "?tab=schedule");
            } else {
                this.setState({creatingLiveSession: false})
                UIUtil.showError();
            }
        }

        if (this.props.showCourseLiveSessions) {
            Api.createCourseLiveSession(this.state.createLiveSessionTitle, this.state.createLiveSessionCategory, this.props.courseId, listener);
        } else {
            Api.createLiveSession(this.state.createLiveSessionTitle, this.state.createLiveSessionCategory, this.state.createLiveSessionPrivate, listener);
        }
    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div style={this.props.showCourseLiveSessions ? {
                    width: '100%', paddingRight: '25px', marginTop: '-10px'
                } : {width: this.props.renderFullWidth ? '90vw' : '75vw', paddingTop: this.props.organization === undefined && '25px', paddingBottom: '25px'}}>
                    {!this.props.showCourseLiveSessions && this.props.organization === undefined && <>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            {/*<Radio.Group value={"grid"} style={{width: '200px'}}>
                                <Radio.Button value="grid"><AppstoreOutlined /></Radio.Button>
                                <Radio.Button value="list"><UnorderedListOutlined /></Radio.Button>
                            </Radio.Group>*/}
                            {/*<h2 style={{height: '25px'}}>My Live Sessions</h2>*/}
                            <h2 style={{height: '25px'}}>Live Sessions</h2>
                            <div style={{flex: '1'}} />
                            <Button type="link" onClick={e => this.setState({createLiveSession: true})}>
                                <PlusOutlined /> Create Live Session
                            </Button>
                        </div>
                        <br />
                    </>}

                    <InfiniteScroll
                        loadMore={this.getNextLiveSessions.bind(this)}
                        hasMore={this.state.hasMore}
                        threshold={750}
                        loader={
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: '45px', marginBottom: '45px'}}>
                                <Spin size="large" tip="Loading..." />
                            </div>
                        }
                        style={{overflow: 'visible'}}>

                        {this.state.items.map((item) => {
                            return ( 
                                <div key={item.id}>
                                    <br />
                                    <TutorLiveSessionItem liveSession={item} organization={this.props.organization} />
                                </div>
                            )
                        })}
                    </InfiniteScroll>

                    {!this.state.loadingItems ? <Empty style={{marginTop: '50px'}} image={Empty.PRESENTED_IMAGE_SIMPLE} description={this.state.items.length > 0 ? "No more live sessions" : "No live sessions"} /> : null}
                    <br />
                </div>

                <Modal
                    title="Create Live Session"
                    visible={this.state.createLiveSession || this.props.createLiveSession}
                    okText="Create"
                    confirmLoading={this.state.creatingLiveSession}
                    okButtonProps={{disabled: this.state.createLiveSessionTitle.trim() === ""}}
                    onOk={() => this.onCreateLiveSession()}
                    onCancel={() => {
                        this.setState({createLiveSession: false, createLiveSessionTitle: "", createLiveSessionCategory: 0, createLiveSessionPrivate: false});
                        if (this.props.onCancel !== undefined) {
                            this.props.onCancel();
                        }
                    }}
                    >
                        {this.props.showCourseLiveSessions && <>
                            <Alert
                                message="Important"
                                description="Live Sessions connected to courses will be recorded"
                                type="info"
                                showIcon
                            />
                            <br />
                        </>}

                        <h5>Title</h5>
                        <Input className="message-input" placeholder="Title" size="large" value={this.state.createLiveSessionTitle} onChange={e => this.setState({createLiveSessionTitle: e.target.value})} 
                        onPressEnter={() => this.onCreateLiveSession()}/>

                        <h5 style={{marginTop: 15}}>Category</h5>
                        <Select value={this.state.createLiveSessionCategory} onChange={value => this.setState({createLiveSessionCategory: value})} style={{ width: '100%' }} size="large">
                            {CATEGORIES.map(category => 
                                <Option value={category.id}>{category.icon} &nbsp;&nbsp;{category.title}</Option>)}
                        </Select>

                        {!this.props.showCourseLiveSessions &&
                        <Checkbox checked={this.state.createLiveSessionPrivate} onChange={e => this.setState({createLiveSessionPrivate: e.target.checked})} style={{marginTop: '15px'}}><LockOutlined /> Private</Checkbox>}
                </Modal>
            </div>
        );
    }

}

export default withMediaQuery(withRouter(TutorMyLiveSessionsPage));